import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { SolicitudProductosViewModel, TProductoSolicitudViewModel, TwEmbalajesViewModel, ComprobarCompatibleViewModel } from './productos.types';
import { Tc } from '../../../core/_infrastructure/types/common';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class ProductosService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getSolicitudProductos(id: number): Observable<SolicitudProductosViewModel> {
        return this.http.get<SolicitudProductosViewModel>(this.baseUrl + 'api/importacion/producto/' + id).pipe();
    }

    getProducto(id: number): Observable<TProductoSolicitudViewModel> {
        return this.http.get<TProductoSolicitudViewModel>(this.baseUrl + 'api/importacion/producto/producto/' + id).pipe();
    }

    getEmbalaje(id: number): Observable<TwEmbalajesViewModel> {
        return this.http.get<TwEmbalajesViewModel>(this.baseUrl + 'api/importacion/producto/embalaje/' + id).pipe();
    }

    getSolicitudPartidasPredua(parametros: string): Observable<TProductoSolicitudViewModel[]> {
        return this.http.get<TProductoSolicitudViewModel[]>(this.baseUrl + 'api/importacion/producto/getSolicitudPartidasPredua' + parametros).pipe();
    }

    editSolicitudProductos(solicitud: SolicitudProductosViewModel): Observable<any> {
        return this.http.put<SolicitudProductosViewModel>(this.baseUrl + 'api/importacion/producto/SaveEquipamientos', solicitud).pipe();
    }

    //editEmbalajeSolicitudProductos(solicitud: SolicitudProductosViewModel): Observable<any> {
    //    return this.http
    //        .put<SolicitudProductosViewModel>(this.baseUrl + 'api/importacion/producto/SaveEmbalaje', solicitud).pipe();
    //}

    createProducto(producto: TProductoSolicitudViewModel): Observable<any> {
        return this.http.post<TProductoSolicitudViewModel>(this.baseUrl + 'api/importacion/producto', producto).pipe();
    }

    createEmbalaje(embalaje: TwEmbalajesViewModel): Observable<any> {
        return this.http.post<TProductoSolicitudViewModel>(this.baseUrl + 'api/importacion/producto/Embalaje', embalaje).pipe();
    }

    editProducto(producto: TProductoSolicitudViewModel): Observable<any> {
        return this.http.put<TProductoSolicitudViewModel>(this.baseUrl + 'api/importacion/producto', producto).pipe();
    }

    editEmbalaje(embalaje: TwEmbalajesViewModel): Observable<any> {
        return this.http.put<TwEmbalajesViewModel>(this.baseUrl + 'api/importacion/producto/Embalaje', embalaje).pipe();
    }

    deleteSolicitudProductos(id: number): Observable<any> {
        return this.http.delete<TProductoSolicitudViewModel>(this.baseUrl + 'api/importacion/producto/' + id).pipe();
    }

    deleteEmbalaje(id: number): Observable<any> {
        return this.http.delete<TwEmbalajesViewModel>(this.baseUrl + 'api/importacion/producto/Embalaje/' + id).pipe();
    }

    getTaricEmbalaje(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/importacion/producto/taricEmbalaje').pipe();
    }

    getEppoEmbalaje(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/importacion/producto/eppoEmbalaje').pipe();
    }

    getUnidadEmbalajeByIdTaric(idTaric: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/importacion/producto/unidadEmbalaje/' + idTaric).pipe();
    }

    getAllConfiguraciones(productoSolicitudCollection: TProductoSolicitudViewModel[]): Observable<any> {
        return this.http
            .post<TProductoSolicitudViewModel[]>(this.baseUrl + 'api/importacion/producto/GetAllConfiguraciones', productoSolicitudCollection)
            .pipe();
    }

    isIncompatible(datosComaptibles: ComprobarCompatibleViewModel): Observable<any> {
        return this.http.post<any>(this.baseUrl + 'api/importacion/producto/IsIncompatible', datosComaptibles).pipe();
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
